export const state = () => ({
    HEAD_ADMIN: 'head_admin',
    ADMIN: 'admin',
    AGUDA: 'aguda',
    USER: 'user'
});

export const getters = {
    AGUDA: state => ({
        text: 'Aguda Members',
        value: state.AGUDA
    }),
    HEAD_ADMIN: state => ({
        text: 'Head Admins',
        value: state.HEAD_ADMIN
    }),
    ADMIN: state => ({
        text: 'Admins',
        value: state.ADMIN
    }),
    USER: state => ({
        text: 'Users',
        value: state.USER
    }),
    ALL_ROLES: (state, getters, rootState, rootGetters) => [
        ...(rootGetters['auth/isHeadAdmin']
            ? [
                  {
                      text: 'Head Admins',
                      value: state.HEAD_ADMIN
                  }
              ]
            : []),
        {
            text: 'Admins',
            value: state.ADMIN
        },
        {
            text: 'Aguda Members',
            value: state.AGUDA
        },
        {
            text: 'Users',
            value: state.USER
        }
    ]
};

export const mutations = {};

export const actions = {};
